/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { differenceInCalendarDays, format } from 'date-fns';
import classNames from 'classnames';
import { ImageWithLoader } from 'app/components';
import { useConfig } from 'app/hooks';
import { TicketBox, Title, SubTitle, Time, Info, OperaSession } from './styles';
import ReactTooltip from 'react-tooltip';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useSelector } from 'react-redux';
import { LineBordered } from '../SelectionTotal/styles';

const propTypes = {
  poster: PropTypes.string,
  title: PropTypes.string,
  cinemaName: PropTypes.string.isRequired,
  screenName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  technologies: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,

  children: PropTypes.node,
  type: PropTypes.oneOf(['wide', 'compact']),
  withTopTitle: PropTypes.bool,
  isCheckoutStep: PropTypes.bool
};

const defaultProps = {
  title: '',
  type: 'wide',
  poster: null,
  withTopTitle: false,
  children: null,
  isCheckoutStep: false
};

const getDayView = (date, t) => {
  const now = new Date();
  const daysDiff = differenceInCalendarDays(date, now);

  if (daysDiff === 0) {
    return t('common.today');
  }

  if (daysDiff === 1) {
    return t('common.tomorrow');
  }

  return format(date, 'dd.MM.yyyy');
};

const getInfo = (date, t) => {
  let parseShowTime = date;

  if (date?.substring(19, 20) === '+' || date?.substring(19, 20) === '-') {
    parseShowTime = date?.substring(0, 19);
  }

  const formattedDate = new Date(parseShowTime);

  return [getDayView(formattedDate, t), format(formattedDate, 'HH:mm')].join(', ');
};

const Ticket = ({
  poster,
  title,
  cinemaName,
  screenName,
  date,
  technologies,
  rating,
  children,
  type,
  withTopTitle,
  isCheckoutStep,
  isAboId,
  operaSessionsData
}) => {
  const [t] = useTranslation();
  const info = useMemo(() => getInfo(date, t), [date]);

  const { country, showingOptions } = useConfig();

  const location = useLocation();
  const email = location?.state?.email;

  const sessionsTickets = useSelector(state => state.sessionsTickets);

  const bookings = useSelector(state => state.bookings);

  const isTitleLongEnough = title && title.length > 25;

  const tooltipContent = isTitleLongEnough ? (
    <ReactTooltip
      place="right"
      type="dark"
      effect="solid"
      offset={{ top: -30, left: 50 }}
      backgroundColor="#2D2D2D"
    >
      {location?.state?.isAboId ? t('purchase.aboSeason') : title}
    </ReactTooltip>
  ) : null;

  const ticketsList = bookings?.booking?.tickets;
  const showTimes = [];

  if (ticketsList != null) {
    ticketsList.map(ticket => {
      const currentTicket = showTimes.find((show) => ticket.sessionDateTime == show.sessionDateTime);
      if (!currentTicket) {
        showTimes.push({ 'movie': ticket.movieName, 'sessionDateTime': ticket.sessionDateTime });
      }
    });
  }

  const operaSessionList = operaSessionsData;
  const operaShowTimes = [];

  if (operaSessionList != null) {
    operaSessionList.map(operaSession => {
      return operaSession?.sessions?.map(opera => {
        operaShowTimes.push({ 'movie': operaSession.titleCalculated, 'sessionDateTime': opera.showtime });
      })
    });
  }

  const ticketContent = () => {
    return isCheckoutStep ? (
      <div className="b-ticket__ticket_info">
        <div className="b-ticket__ticket_info_cotainer">
          {/* <Title>{title || t('movies.no_title')}</Title> */}
          <span>
            {tooltipContent}
            <Title data-tip={title || t('movies.no_title')} style={{ position: 'relative', top: '.4rem', whiteSpace: "nowrap", width: "356px", overflow: "hidden", textOverflow: "ellipsis" }}>{location?.state?.isAboId ? t('purchase.aboSeason') : title || t('movies.no_title')}</Title>
          </span>
          <SubTitle>{cinemaName}</SubTitle>
          {!location?.state?.isAboId && <Time>{info}</Time>}
          {screenName ? <Info>{screenName}</Info> : null}
          {technologies ? <Info>{technologies}</Info> : null}
          {country === 'bih' ? null : (
            showingOptions.ageratingvisible && <Info>
              {t('common.age_rating')}: {rating}
            </Info>
          )}
        </div>
        <ImageWithLoader imgSrc={poster} imgTitle={title} />
      </div>
    ) : (
      <Fragment>
        <ImageWithLoader imgSrc={poster} imgTitle={title} />
        {/* this one */}
        <Title>{isAboId ? t('purchase.aboSeason') : showTimes.length > 1 ? t('purchase.aboSeason') : title || t('movies.no_title')}</Title>
      </Fragment>
    );
  };

  return (
    <div style={{ 'flex-direction': 'column', 'display': type == 'compact' ? 'flex' : 'block' }}>
      <TicketBox className={classNames(`_${type}`, { checkout_step: isCheckoutStep })}>
        {withTopTitle ? (
          <Fragment>
            <Title>{email ? t('purchase.season') : location?.state?.isAboId ? t('purchase.aboSeason') : title || t('movies.no_title')}</Title>
            <ImageWithLoader imgSrc={poster} imgTitle={title} />
          </Fragment>
        ) : (
          ticketContent()
        )}
        {!isCheckoutStep ? (
          <>
            <SubTitle>{cinemaName}</SubTitle>
            {screenName ? <Info>{screenName}</Info> : null}
            {technologies ? <Info>{technologies}</Info> : null}
            {country === 'bih' ? null : (
              showingOptions.ageratingvisible && <Info>
                {t('common.age_rating')}: {rating}
              </Info>
            )}

            {(type == 'wide' && !isAboId)
              ? <Time>{info}</Time>
              : operaShowTimes.length > 0
                ? operaShowTimes?.map(ticket => {
                  return (
                    <OperaSession key={ticket.sessionDateTime} style={{ float: type == 'compact' ? 'left' : null }}>
                      <span>{ticket?.movie}</span>
                      <span>{getInfo(ticket.sessionDateTime, t)}</span>
                    </OperaSession>
                  );
                }) : null}
            {type == 'wide' ? children : null}
          </>
        ) : (
          <div className="b-ticket__child_section">{children}</div>
        )}
      </TicketBox>
      {type == 'compact'
        ? <div>{email || location?.state?.isAboId ? sessionsTickets?.sessionsPassData?.sessions?.map(session => {
          return (
            <LineBordered key={session.id} style={{ 'font-size': '1.2rem', fontWeight: 'bold' }}>
              <span style={{ maxWidth: "160px" }}>{session?.scheduledFilm?.title}</span>
              <span>{getInfo(session.showtime, t)}</span>
            </LineBordered>
          );
        }) : showTimes.length > 0
          ? showTimes?.map(ticket => {
            return (
              <LineBordered key={ticket.sessionDateTime} style={{ 'font-size': '1.2rem', fontWeight: 'bold' }}>
                <span style={{ maxWidth: "200px" }}>{ticket?.movie}</span>
                <span>{getInfo(ticket.sessionDateTime, t)}</span>
              </LineBordered>
            );
          })
          : <Time>{info}</Time>}
          {children}</div>
        : null}
    </div>
  );
};

Ticket.defaultProps = defaultProps;
Ticket.propTypes = propTypes;
export default Ticket;
